import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Menu', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-item`]: {
        transition,
        borderRadius: '10px !important',
        marginInline: 4,

        '&:hover': {
          background: `${purple[500]}10 !important`,
          color: `${purple[500]} !important`,
        },
      },

      [`${componentCls}-item-selected`]: {
        background: `${purple[500]}15 !important`,
        color: `${purple[600]} !important`,
        fontWeight: 600,

        '&:after': {
          borderColor: `${purple[500]} !important`,
        },
      },

      // 水平菜单下划线
      [`&${componentCls}-horizontal`]: {
        [`${componentCls}-item-selected:after, ${componentCls}-item-active:after`]: {
          borderBottomColor: `${purple[500]} !important`,
          borderBottomWidth: '2px !important',
        },
      },
    },
  }
})
